import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-thanks-modal',
  templateUrl: './thanks-modal.component.html',
  standalone: true,
  imports: [TranslocoPipe
  ],
})
export class ThanksModalComponent {
  @Input() data: any;
  @Input() close: ((event?: any) => void) | undefined;
}
